import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';
import { DataTableComponent } from '../data-table.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tr[appTr]',
  templateUrl: './data-table-row.component.html',
  styleUrls: ['./data-table-row.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTableRowComponent implements OnInit {
  @Input() expandableRow: DataTableRowComponent;
  @Input() item: any;

  @Output() expandToggle = new EventEmitter<boolean>();

  @HostBinding('class.data-table__row') class = true;
  @HostBinding('class.data-table__row--expandable') expandable = false;
  @HostBinding('class.data-table__row--expanded') expanded = false;
  @HostBinding('class.data-table__row_expandable-content') expandableContent = false;

  @HostListener('click', ['$event'])
  onClick(event: PointerEvent): void {
    if (this.expandableRow && (event.target as Element).id === 'table-expand') {
      this.expanded = !this.expanded;
      this.expandableRow.toggle();
      if (this.item) {
        this.item.expanded = this.expanded;
      }
      this.expandToggle.emit(this.expanded);
    }
  }

  constructor(private tableComponent: DataTableComponent) {
  }

  ngOnInit(): void {
    if (this.expandableRow) {
      this.expandableRow.expandableContent = true;
      this.expandable = true;
      this.tableComponent.expandable = true;

      if (this.item && this.item.expanded) {
        this.expanded = this.expandableRow.expanded = true;
      }
    }
  }

  toggle(): void {
    this.expanded = !this.expanded;
  }
}
